import React from 'react';

import { Box } from '@styleseat/ui';
import {
  BodyText,
  Stack,
  HeaderText,
} from '../../../ui';

import ImpactScale from '../../SearchRank/ImpactScale';

type MessageProps = {
  impact: 'low' | 'medium' | 'high';
};

const Message:
React.FC<MessageProps> = ({
  impact = 'low',
}) => (
  <Stack
    space={16}
    paddingX={4}
  >
    <Box>
      <HeaderText
        level="3"
        testID="appointment_cancel_search_rank_impact_message_title"
      >
        Search Ranking
      </HeaderText>
      <BodyText
        textAlign="left"
        weight="thin"
        testID="appointment_cancel_search_rank_impact_message_body"
      >
        <BodyText
          weight="thin"
        >
          {'This cancellation will have a '}
        </BodyText>
        <BodyText
          emphasize
        >
          {`${impact} negative impact`}
        </BodyText>
        <BodyText
          weight="thin"
        >
          {' to your search ranking because we sent you this client.'}
        </BodyText>
      </BodyText>
    </Box>
    <ImpactScale
      impact={impact}
    />
  </Stack>
);

export default Message;
